<template lang="html">
  <modal ref="modal" hide-close full>
    <div class="content" v-if="lastDrafted">
      <draft-selected-player :player="lastDraftedPlayer" :reveal="!start" />

      <div class="picks">
        <div class="pick-display">
          <b>{{ lastTeamToPick.name }}</b>
        </div>

        <div ref="team" class="team">
          <div
            v-for="({ pick, name, position, keeper }, i) in lastTeamToPick.picks"
            :class="['player', { start, bold: i === lastTeamToPick.picks.length - 1 }]"
            :key="i"
          >
            {{ `${position} ${name} (${pick})` }}
            <b class="primary-color">{{ keeper ? 'K': '' }}</b>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import DraftSelectedPlayer from './DraftSelectedPlayer';

export default {
  components: {
    DraftSelectedPlayer,
  },

  data() {
    return {
      start: true,
      pickInTimeout: null,
      playerPickTimeout: null,
    };
  },

  computed: {
    ...mapState({
      id: ({ draft }) => draft.draft.id,
      lastDrafted: ({ draft }) => draft.draft.lastDrafted,
    }),

    ...mapGetters({
      lastTeamToPick: 'draft/lastTeamToPick',
      lastDraftedPlayer: 'draft/lastDraftedPlayer',
    }),
  },

  watch: {
    lastDrafted(pick, lastPick) {
      if (pick && pick !== lastPick) {
        clearTimeout(this.pickInTimeout);
        clearTimeout(this.playerPickTimeout);

        this.start = true;
        this.$refs.modal.open();

        if (this.$refs.team) {
          this.$refs.team.scrollTop = this.$refs.team.scrollHeight;
        }

        this.pickInTimeout = setTimeout(() => {
          this.start = false;

          this.playerPickTimeout = setTimeout(() => {
            this.$refs.modal.close();
          }, 4000);
        }, 2000);
      }
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .content {
    display: flex;
  }

  .picks {
    padding: $gp * 1.5;
    min-width: px-to-rem(320px);
    background-color: $dark-color-active;
    color: $white-color;
    display: flex;
    flex-direction: column;
  }

  .team {
    flex: 1 1 0px;
    overflow-y: auto;
  }

  .pick-display {
    margin-bottom: $gp;
  }

  .player {
    margin-bottom: $gp / 2;

    &:last-child {
      @include transition(opacity);
      opacity: 1;
    }

    &.start {
      &:last-child {
        opacity: 0;
      }
    }
  }
</style>
